module.exports = __webpack_public_path__ + "img/lead-daytrips.72535e1f.svg";